import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { useLocation } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { FormInput } from "../../components/forms/inputs";
import { DropdownInput } from "../../components/forms/dropdown";
import { PropertyInput } from "../../components/forms/property-input";
import { isEmpty, isNull } from "../../_helpers/isNull";
import { UseAuthentication } from "../../services/authentication/authentication.context";
import { UseCarContext } from "../../services/products/product.context";
import { AppAlert } from "../../components/utilities/alert";
import { brands } from "../../_helpers/cars-data";
import { getCarData } from "../../services/products/products.services";
import { formatImageUrl } from "../../_helpers/format-image-url";


export const CarUpdateForm = () => {

    const car = useLocation().state;

    const { uploadImage, deleteImage, updateCar } = UseCarContext();

    const { token } = UseAuthentication();

    const [openNext, setOpenNext] = useState(false);
    const [carInfo, setCarInfo] = useState(car);




    const [productData, setProductData] = useState({
        brand: carInfo?.brand,
        model: carInfo?.model,
        year: carInfo?.year,
        properties: carInfo?.properties,
        price: carInfo?.cost,
        images: carInfo?.images,
        discount: carInfo?.discount
    });

    const [propCaption, setPropCaption] = useState('');
    const [propValue, setPropValue] = useState('');
    const [previews, setPreviews] = useState(car?.images);
    const [onAlert, setOnAlert] = useState();

    const { brand, model, year, price, properties, images, discount } = productData;

    const bttnRef = useRef();

    const handleUpdate = (prop) => {
        setPropCaption(Object.keys(prop)[0]);
        setPropValue(Object.values(prop)[0]);
        setProductData((d) => ({
            ...d, properties: d.properties.filter((v) => {
                return Object.keys(v)[0] !== Object.keys(prop)[0] && Object.values(v)[0] !== Object.values(prop)[0];
            })
        }))
    }

    const handleRemove = (prop) => {
        setProductData((d) => ({
            ...d, properties: d.properties.filter((v) => {
                return Object.keys(v)[0] !== Object.keys(prop)[0] && Object.values(v)[0] !== Object.values(prop)[0];
            })
        }))
    }

    const handleInput = (e) => {
        e.preventDefault();
        setProductData((data) => ({ ...data, [e.target.name]: e.target.value }));
    }

    const handleAddImage = async (e) => {
        const resp = await uploadImage(e.target.files[0]);
        if (resp?.error) {
            setOnAlert({
                caption: 'Upload Error!',
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
        const fileUrl = resp?.uri;
        console.log(resp);
        setProductData((data) => ({ ...data, images: [...images, fileUrl] }));
        setPreviews((prev) => ([
            ...prev, {
                url: fileUrl,
                temPath: URL.createObjectURL(e.target.files[0])
            }]));
        console.log(previews);
    }

    const handleRemoveImage = async (fileUri) => {
        const resp = await deleteImage(fileUri);
        if (resp?.error) {
            alert("Image removel failed");
            return console.log({ error: resp?.error });
        }
        if (resp?.success) {
            setPreviews((prev) => prev.filter((obj) => obj.url !== fileUri))
            setProductData((d) => ({ ...d, images: d.images.filter((uri) => uri !== fileUri) }))
            return alert("Image removed!");
        }
    }

    const handleUpdatecarInfo = async (data, token) => {
        //validate data
        const strValues = ['brand', 'model', 'year', 'price'];
        const arrValues = ['properties', 'images'];

        //check for null values on strings and empty arrays for input 
        const invalidStrVal = strValues.some((val) => isNull(productData[val]));
        const inValidArrVal = arrValues.some((arr) => isEmpty(productData[arr]));

        //reject invalid input
        if (inValidArrVal || invalidStrVal) {
            setOnAlert({
                caption: 'Invalid input!',
                message: 'Please provide all the required information!',
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }

        // console.log(productData);
        const resp = await updateCar(productData, car?._id, token);
        if (resp?.error) {
            setOnAlert({
                caption: 'Update failed!',
                message: 'Something went wrong!',
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
        if (resp?.message) {
            setOnAlert({
                caption: 'Success!',
                message: resp?.message,
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        } else {
            setOnAlert({
                caption: 'Uncaught error!',
                message: 'Update failed for some reason!',
                accept: "Ok",
                onAccept: () => setOnAlert()
            });
            return;
        }
    }

    useEffect(() => {
        const handleSetImages = () => {
            const modified = carInfo?.images?.map((image) => ({
                url: image,
                temPath: formatImageUrl(image)
            }))

            return modified;
        }
        const resp = handleSetImages();
        setPreviews(resp);
    }, [carInfo?.images])

    const brandNames = brands;

    return (
        <div className="app-pg f-pg">
            <SiteHeader pageTitle={"Add a product"} />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onClose={() => setOnAlert()}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                />
            )}
            <div className="form-conatiner add-product-form-container">
                <div className="md-txt hd">
                    Update car data
                </div>
                {!openNext ?
                    <form
                        className="initial-form app-form"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <div className="sub-form-caption">
                            Update/Add car images (4 max)
                        </div>
                        <div className="images-box">
                            <button
                                className="img-add-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (previews?.length >= 4) {
                                        alert("Maximum uploads attained! You can only add a maximum of four images per product.");
                                        return;
                                    }
                                    bttnRef.current.click()
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                            <input
                                type="file"
                                className="image-input"
                                onChange={(e) => {
                                    e.preventDefault();
                                    handleAddImage(e)
                                }}
                                ref={bttnRef}
                            />
                            {previews?.map((prev, k) => (
                                <div className="preview-unit" key={k}>
                                    <button
                                        className="remove-img"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleRemoveImage(prev?.url);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faClose} />
                                    </button>
                                    <img src={prev?.temPath} alt="" className="preview-img" />
                                </div>
                            ))}
                        </div>
                        <div className="sub-form-caption">
                            Car details
                        </div>
                        <FormInput
                            value={model}
                            label={'Car model'}
                            name={'model'}
                            onChange={(e) => handleInput(e)}
                            type={'text'}
                            required={true}
                        />
                        <DropdownInput
                            value={brand}
                            defaultValue={"--- Select car brand ---"}
                            onChange={(e) => handleInput(e)}
                            name={'brand'}
                            data={brandNames}
                        />
                        <FormInput
                            value={year}
                            label={'Model year'}
                            name={'year'}
                            onChange={(e) => handleInput(e)}
                            type={'number'}
                            required={true}
                        />
                        <FormInput
                            value={price}
                            label={'Car price'}
                            name={'price'}
                            onChange={(e) => handleInput(e)}
                            type={'number'}
                            required={true}
                        />
                        <FormInput
                            value={discount}
                            label={'Discount'}
                            name={'discount'}
                            onChange={(e) => handleInput(e)}
                            type={'number'}
                            required={true}
                        />
                        <div className="image-input-conatiner">

                        </div>
                        <button
                            className="form-button"
                            onClick={() => setOpenNext(true)}
                        >
                            Next
                        </button>
                    </form> :
                    <form
                        className="initial-form app-form"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <div className="sub-form-caption">
                            Product properties
                        </div>
                        <div className="properties-list">
                            {properties?.map((prop, k) => (
                                <div className="prop-list-row" key={k}>

                                    <div className="prop-data-box">
                                        <span className="prop-title">{Object.keys(prop)[0]}</span>
                                        <span className="prop-data">{Object.values(prop)[0]}</span>
                                    </div>

                                    <div className="prop-edit-box">
                                        <button
                                            className="edit-bttn edit"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleUpdate(prop);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button
                                            className="edit-bttn del"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleRemove(prop);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <PropertyInput
                            propCaption={propCaption}
                            propValue={propValue}
                            onChangeCaption={(e) => setPropCaption(e.target.value)}
                            onChangeValue={(e) => setPropValue(e.target.value)}
                            onAddProp={(e) => {
                                e.preventDefault();
                                if (isNull(propCaption) || isNull(propValue)) {
                                    return alert('Null values are not allowed for property caption or description');
                                }
                                setProductData((d) => ({
                                    ...d,
                                    properties: [...d.properties, { [propCaption]: propValue }]
                                }));
                                setPropCaption('');
                                setPropValue('');
                            }}
                        />
                        <button
                            className="form-button"
                            onClick={() => setOpenNext(false)}
                        >
                            Previous
                        </button>
                        <button
                            className="form-button"
                            onClick={async () => {
                                await handleUpdatecarInfo(productData, token);
                                //console.log({ token });
                            }}
                        >
                            Submit
                        </button>
                    </form>
                }
            </div>
        </div>
    )
}